/* eslint-disable no-underscore-dangle */
import { apiClient, handleResponse } from './axios';

async function getTeacherById(id) {
  try {
    const response = await apiClient.get(`/teacher/${id}`);
    const teachers = await handleResponse(response);
    return teachers;
  } catch (error) {
    return error.response;
  }
}

const teacherServices = {
  getTeacherById,
};

export default teacherServices;
